import { createReducer, on } from '@ngrx/store';
import { COLOR_PALETTE, FONT_STYLE, ThemeState } from '../model/theme.model';
import { loadTheme, setDarkMode, setFont, setPrimaryColor } from '../action/theme.action';


export const initialState: ThemeState = {
    primaryColor: 'red',
    font: 'Inter',
    darkMode: false,
    colorPalette: COLOR_PALETTE,
    fontStyles: FONT_STYLE,
};

export const themeReducer = createReducer(
    initialState,
    on(setPrimaryColor, (state, { color }) => ({ ...state, primaryColor: color })),
    on(setFont, (state, { font }) => ({ ...state, font: font })),
    on(setDarkMode, (state, { darkMode }) => ({ ...state, darkMode: darkMode })),
    on(loadTheme, (state) => ({ ...state })),
);
